// iter_302 · 概要（状態カード5つ + 次にすること + 詳細情報）
import { ArrowsClockwise, Plus, ArrowRight } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { Panel, Pill, Collapse, Spinner, Help } from './shared';
import ReadingConfig from './ReadingConfig';

export default function Overview({ data, loading, onReload, onGo }) {
  const cards = data?.cards || [];
  return (
    <div className="space-y-4">
      <Panel testId="learn-overview"
        action={(
          <Button variant="outline" className="h-9 text-[12px]" onClick={onReload}
            disabled={loading} data-testid="learn-overview-refresh">
            {loading ? <Spinner /> : <ArrowsClockwise size={13} className="mr-1" />}
            <span className="ml-1">更新</span>
          </Button>
        )}>
        <div className="grid grid-cols-2 gap-2 lg:grid-cols-5">
          {cards.map((c) => (
            <button key={c.key} type="button" onClick={() => onGo(c.area)}
              className="min-h-[84px] rounded-md border border-zinc-200 px-3 py-2 text-left transition-colors duration-200 hover:bg-zinc-50"
              data-testid={`learn-card-${c.key}`}>
              <p className="text-[11px] text-zinc-500">{c.label_ja}</p>
              <p className="pt-0.5 text-xl font-semibold tabular-nums text-zinc-900">
                {c.value === null || c.value === undefined ? '—' : c.value}
                <span className="pl-0.5 text-[11px] font-normal text-zinc-500">{c.unit_ja}</span>
              </p>
              <p className="pt-0.5 text-[10.5px] leading-snug text-zinc-500">{c.hint_ja}</p>
            </button>
          ))}
        </div>
      </Panel>

      <Panel title="次にすること" testId="learn-next-actions"
        hint="いま安全に進められる作業だけを案内します。">
        <div className="space-y-1.5">
          <div className="flex flex-wrap items-center justify-between gap-2 rounded-md border border-zinc-200 px-3 py-2"
            data-testid="learn-next-responsibilities">
            <p className="text-[12.5px] text-zinc-800">
              読み取った責任者を、書類ごとにまとめて確認できます
              {data?.measures?.判読不能の責任者 !== undefined
                && `（判読不能 ${data.measures.判読不能の責任者}件）`}
            </p>
            <a href="/documents/responsibilities"
              className="inline-flex min-h-[36px] items-center rounded-md bg-teal-700 px-3 text-[12px] text-white hover:bg-teal-800"
              data-testid="learn-next-action-responsibilities">
              担当者の一括確認を開く<ArrowRight size={12} className="ml-1" />
            </a>
          </div>
          {(data?.next_actions || []).map((n) => (
            <div key={n.key}
              className="flex flex-wrap items-center justify-between gap-2 rounded-md border border-zinc-200 px-3 py-2"
              data-testid={`learn-next-${n.key}`}>
              <p className="text-[12.5px] text-zinc-800">{n.text_ja}</p>
              <Button size="sm" className="h-9 bg-teal-700 text-[12px] hover:bg-teal-800"
                onClick={() => onGo(n.area)} data-testid={`learn-next-action-${n.key}`}>
                {n.action_label_ja}<ArrowRight size={12} className="ml-1" />
              </Button>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap items-center gap-3 pt-3">
          <Button className="h-10 bg-teal-700 text-[12.5px] hover:bg-teal-800"
            onClick={() => onGo('teach')} data-testid="learn-overview-primary">
            <Plus size={13} className="mr-1" />学習用の書類を追加
          </Button>
          <Help label="学習候補" testId="learn-help-candidate">
            修正内容から作られた、今後の読み取りルールの候補です。承認するまで使用されません。
          </Help>
        </div>
      </Panel>

      <Panel testId="learn-overview-detail">
        <ReadingConfig />
        <div className="pt-2">
          <Collapse label="詳細情報（技術情報）" testId="learn-overview-technical">
          <div className="space-y-2">
            <p className="flex flex-wrap gap-1.5">
              <Pill tone={data?.active_version ? 'teal' : 'zinc'} testId="learn-overview-active">
                {data?.active_version
                  ? `有効な学習内容: バージョン ${data.active_version.version}（${data.active_version.pattern_count}件）`
                  : '有効な学習内容: なし'}
              </Pill>
              <Pill>学習用書類 {data?.examples?.total || 0}件</Pill>
              <Pill>承認待ち {data?.proposals?.by_status?.proposed || 0}件</Pill>
              <Pill>却下 {data?.proposals?.by_status?.rejected || 0}件</Pill>
            </p>
            <div className="grid grid-cols-1 gap-1 sm:grid-cols-2">
              {Object.entries(data?.measures || {}).map(([k, v]) => (
                <p key={k} className="text-[11.5px] text-zinc-600" data-testid={`learn-measure-${k}`}>
                  {k}: <span className="tabular-nums">{v ?? '—'}</span>
                </p>
              ))}
            </div>
            <p className="text-[11px] text-zinc-500">
              現在の検証状況: {data?.validation_status_ja || '—'}
              {data?.last_change && ` · 最後の変更: バージョン ${data.last_change.version}（${data.last_change.status_label_ja}）`}
            </p>
            <p className="text-[11px] text-zinc-400">
              サービス: {data?.service_version} · モデルの重みは変更していません
            </p>
          </div>
          </Collapse>
        </div>
      </Panel>
    </div>
  );
}
